/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';
import { TreeSelect } from 'antd';
import './index.css';
import toast from 'react-hot-toast';
import * as D from './styles';
interface IITem {
    title?: string;
    value?: string;
    children?: IItem[];
}

export interface IMultiSelectInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    errorText1?: string;
    readOnly?: boolean;
    disabled?: boolean;
    value?: string;
    initialItems: IITem[];
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const MultiSelectInput = ({
    id,
    fontScale,

    label,
    labelColor,
    options,
    errorText,
    errorText1,
    value,
    required,
    placeholder,
    onCompChange,
    hasError,
    readOnly,
    disabled,
    initialItems,
}: IMultiSelectInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);
    const onChange = (_id: string, e: any) => {
        console.log('lkj->', _id, e);
        if (_id?.startsWith('_')) {
            setTextValue('');
            toast.error(errorText1 ?? '');
            onCompChange && onCompChange(id, undefined);
        } else {
            setTextValue(_id);
            onCompChange && onCompChange(id, _id);
        }
    };

    console.log('lmn->', initialItems, textValue);
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });
    return (
        <>
            <Form.Group id={id} className="formgroup">
                {_renderLabelIf()}
                <InputGroup
                    className="formcontrol input-group-bt"
                    id={`input-group-${id}`}
                >
                    <D.MyTreeSelect
                        showSearch
                        disabled={disabled}
                        fontScale={fontScale}
                        treeDefaultExpandAll={true}
                        id={`input-${id}`}
                        style={{
                            width: '100%',
                        }}
                        value={textValue}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={placeholder}
                        allowClear
                        onChange={onChange}
                        className=""
                        treeData={initialItems ?? []}
                    />
                </InputGroup>
                {_renderErrorTextIf()}
            </Form.Group>
        </>
    );
};

MultiSelectInput.defaultProps = {
    required: false,
    hasError: false,
    readOnly: false,
};
